<template>
  <div class="preview-container">
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div class="preview-content">
      <div class="product-name-block">
        <va-input :value="productInfo?.name || ''" label="Название" disabled />
        <div v-if="productInfo?.id != null" class="product-id-hint">
          ID: {{ productInfo.id }}
        </div>
      </div>
      <va-input
        type="textarea"
        label="Описание"
        :value="productInfo?.description || ''"
        :min-rows="2"
        :max-rows="4"
        disabled
        class="mb-4"
      />
      <!-- card type -->
      <div class="mb-4">
        <h2 class="mb-2">Размер карточки товара</h2>
        <va-input :value="cardTypeLabel" disabled />
      </div>
      <!-- price -->
      <div class="mb-4">
        <h2 class="mb-2">Цена</h2>
        <va-input :value="productPrice" label="Текущая цена" disabled />
        <va-input
          v-if="productOldPrice"
          :value="productOldPrice"
          label="Старая цена"
          disabled
          class="mt-2"
        />
      </div>
      <!-- filters -->
      <div class="mb-4">
        <h2 class="mb-2">Фильтры</h2>
        <va-input :value="isNewLabel" label="Новинка" disabled />
        <va-input
          :value="isDiscountLabel"
          label="Скидка"
          disabled
          class="mt-2"
        />
      </div>
      <!-- size dimensions -->
      <div
        v-if="productInfo.size_width || productInfo.size_height"
        class="mb-4"
      >
        <h2 class="mb-2">Размеры (габариты)</h2>
        <div v-if="productInfo.size_width" class="mb-2">
          <va-input :value="`Ширина: ${productInfo.size_width}`" disabled />
        </div>
        <div v-if="productInfo.size_height">
          <va-input :value="`Высота: ${productInfo.size_height}`" disabled />
        </div>
      </div>
      <!-- sizes -->
      <div v-if="productInfo.sizes && productInfo.sizes.length" class="mb-4">
        <h2 class="mb-2">Размеры товара</h2>
        <fieldset>
          <div v-for="size in productInfo.sizes" :key="size.id" class="mb-2">
            <va-input
              :value="`${size.name || size.slug} - Кол-во: ${size.qty || 0}`"
              disabled
            />
          </div>
        </fieldset>
      </div>
      <!-- florist -->
      <div v-if="productInfo.florist" class="mb-4">
        <h2 class="mb-2">Флорист (автор)</h2>
        <va-input :value="productInfo.florist.name" disabled />
      </div>
      <!-- meta fields -->
      <div
        v-if="productInfo.meta_title || productInfo.meta_description"
        class="mb-4"
      >
        <h2 class="mb-2">SEO</h2>
        <div v-if="productInfo.meta_title" class="mb-2">
          <va-input
            :value="productInfo.meta_title"
            label="Meta Title"
            disabled
          />
        </div>
        <div v-if="productInfo.meta_description">
          <va-input
            type="textarea"
            :value="productInfo.meta_description"
            label="Meta Description"
            :min-rows="2"
            :max-rows="3"
            disabled
          />
        </div>
      </div>
      <!-- delivery and payment info -->
      <div v-if="productInfo.delivery_info" class="mb-4">
        <h2 class="mb-2">Информация о доставке</h2>
        <va-input
          type="textarea"
          :value="productInfo.delivery_info"
          :min-rows="2"
          :max-rows="4"
          disabled
        />
      </div>
      <div v-if="productInfo.payment_info" class="mb-4">
        <h2 class="mb-2">Информация об оплате</h2>
        <va-input
          type="textarea"
          :value="productInfo.payment_info"
          :min-rows="2"
          :max-rows="4"
          disabled
        />
      </div>

      <!-- photos -->
      <div class="mb-4">
        <h2 class="mb-2">Фотографии</h2>
        <div class="photos-row">
          <div
            class="image"
            v-for="(image, imageIndex) in images"
            :key="imageIndex"
            @click="index = imageIndex"
            :style="{
              backgroundImage: 'url(' + image + ')',
              width: '200px',
              height: '200px',
              display: 'inline-flex',
            }"
          ></div>
        </div>
      </div>
      <!-- related products -->
      <div
        v-if="
          productInfo.related_products && productInfo.related_products.length
        "
        class="mb-4"
      >
        <h2 class="mb-2">Дополнительные товары</h2>
        <fieldset>
          <div
            v-for="relatedProduct in productInfo.related_products"
            :key="relatedProduct.id"
            class="mb-2"
          >
            <va-input :value="relatedProduct.name" disabled />
          </div>
        </fieldset>
      </div>
      <!-- related categories -->
      <div
        v-if="
          productInfo.related_categories &&
          productInfo.related_categories.length
        "
        class="mb-4"
      >
        <h2 class="mb-2">Сопутствующие категории</h2>
        <fieldset>
          <div
            v-for="category in productInfo.related_categories"
            :key="category.id"
            class="mb-2"
          >
            <va-input :value="category.name" disabled />
          </div>
        </fieldset>
      </div>
      <!-- categories -->
      <div v-if="productInfo?.categories && productInfo.categories.length" class="mb-4">
        <h2 class="mb-2">Категории</h2>
        <fieldset>
          <div
            v-for="category in productInfo.categories"
            :key="category.id"
            class="mb-2"
          >
            <va-input :value="category.name" disabled />
          </div>
        </fieldset>
      </div>
      <!-- colors -->
      <div v-if="productInfo.colors && productInfo.colors.length" class="mb-4">
        <h2 class="mb-2">Цвета</h2>
        <fieldset>
          <div v-for="color in productInfo.colors" :key="color.id" class="mb-2">
            <va-input :value="color.name" disabled />
          </div>
        </fieldset>
      </div>
      <!-- components -->
      <div
        v-if="productInfo.components && productInfo.components.length"
        class="mb-4"
      >
        <h2 class="mb-2">Состав</h2>
        <fieldset>
          <div
            v-for="component in productInfo.components"
            :key="component.id"
            class="mb-2"
          >
            <va-input :value="component.title" disabled />
          </div>
        </fieldset>
      </div>
      <!-- reasons -->
      <div
        v-if="productInfo.reasons && productInfo.reasons.length"
        class="mb-4"
      >
        <h2 class="mb-2">Повод</h2>
        <fieldset>
          <div
            v-for="reason in productInfo.reasons"
            :key="reason.id"
            class="mb-2"
          >
            <va-input :value="reason.name" disabled />
          </div>
        </fieldset>
      </div>
      <!-- tags -->
      <div v-if="productInfo.tags && productInfo.tags.length" class="mb-4">
        <h2 class="mb-2">Теги</h2>
        <fieldset>
          <div v-for="tag in productInfo.tags" :key="tag.id" class="mb-2">
            <va-input :value="tag.name" disabled />
          </div>
        </fieldset>
      </div>
    </div>

    <div class="mt-3 text-center action-buttons-fixed">
      <va-button type="button" color="primary" @click="$emit('hide', false)">
        Закрыть
      </va-button>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
export default {
  components: {
    gallery: VueGallery,
  },
  props: {
    productInfo: {
      type: Object,
      require: true,
      default: () => {},
    },
  },

  computed: {
    smallSize() {
      if (!this.productInfo || !this.productInfo.sizes) return null;
      return this.productInfo.sizes.find(
        (size) => size.slug === "small" || size.name?.toLowerCase() === "small"
      );
    },
    productPrice() {
      if (!this.productInfo || !this.productInfo.price) return "";
      return this.productInfo.price.current
        ? `${this.productInfo.price.current} р.`
        : "";
    },
    productOldPrice() {
      if (!this.productInfo || !this.productInfo.price || !this.productInfo.price.old) return "";
      return `${this.productInfo.price.old} р.`;
    },
    isNewLabel() {
      if (!this.productInfo) return "Нет";
      return this.productInfo.is_new ? "Да" : "Нет";
    },
    isDiscountLabel() {
      if (!this.productInfo) return "Нет";
      return this.productInfo.is_discount ? "Да" : "Нет";
    },
    cardTypeLabel() {
      if (!this.productInfo) return "Стандартная";
      const cardType = this.productInfo.card_type || "normal";
      return cardType === "big" ? "Большая" : "Стандартная";
    },
  },
  watch: {
    productInfo: {
      handler(newVal) {
        this.updateImages(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.updateImages(this.productInfo);
  },
  methods: {
    updateImages(productInfo) {
      if (productInfo && productInfo.photos && Array.isArray(productInfo.photos)) {
        this.images = productInfo.photos.map((element) => element.url);
      } else {
        this.images = [];
      }
    },
  },
  data() {
    return {
      images: [],
      index: null,
    };
  },
};
</script>

<style scoped>
.preview-container {
  padding-bottom: 80px;
}

.preview-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;
}

.product-name-block {
  display: flex;
  flex-direction: column;
}

.product-id-hint {
  margin-top: 6px;
  color: #666;
  font-size: 0.875rem;
}

.image {
  cursor: pointer;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 2px solid #6d6d6d;
  border-radius: 11px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.photos-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  padding-bottom: 10px;
}

.action-buttons-fixed {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  padding: 16px 0;
  z-index: 10;
  border-top: 1px solid #e0e0e0;
  margin-top: 20px;
  grid-column: 1 / -1;
}
</style>
